import { useMemo } from 'react'
import { cmsDataService } from '@/content/services/cms.data.service'

export const useInitialData = () => {
    return useMemo(() => cmsDataService.get(), [])
}
